<template>
  <v-tooltip top max-width="300">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <!-- Square shape -->
        <div
          v-if="shape === 'square'"
          class="custom-indicator square-indicator"
          :style="customStyle"
        >
          <strong>{{ formattedNumber }}</strong>
        </div>

        <!-- Pill shape -->
        <div
          v-else-if="shape === 'pill'"
          class="custom-indicator pill-indicator"
          :style="customStyle"
        >
          <strong>{{ formattedNumber }}</strong>
        </div>

        <!-- Circle shape (default) -->
        <v-avatar
          v-else
          :color="bgColor"
          size="24"
          class="circle-indicator"
          :class="{ 'white--text': !textColor || textColor === 'white' }"
        >
          <strong :style="{ color: textColor || 'white' }">{{ formattedNumber }}</strong>
        </v-avatar>
      </div>
    </template>
    <span>{{ tooltipMessage }}</span>
  </v-tooltip>
</template>

<script>
import numberFormats from '@enums/number-formats';

export default {
  props: {
    number: {
      type: Number,
      default: () => 0,
    },
    tooltipMessage: {
      type: String,
      default: () => null,
    },
    shape: {
      type: String,
      default: 'circle',
      validator: value => ['circle', 'square', 'pill'].includes(value),
    },
    bgColor: {
      type: String,
      default: '#4CAF50',
    },
    textColor: {
      type: String,
      default: null,
    },
    outlineColor: {
      type: String,
      default: 'black',
    },
  },
  computed: {
    customStyle() {
      return {
        backgroundColor: this.bgColor || 'white',
        color: this.textColor || 'inherit',
        borderColor: this.outlineColor || 'black',
      };
    },

    formattedNumber() {
      return this.formatNumber({ number: this.number, format: numberFormats.integer });
    },
  },
};
</script>

<style lang="scss" scoped>
.circle-indicator {
  font-size: 12px;
  cursor: default;
}

.custom-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  font-size: 12px;
  height: 24px;
  width: 24px;
  cursor: default;
}

.square-indicator {
  border-radius: 4px;
}

.pill-indicator {
  border-radius: 12px;
}
</style>
